import {REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO} from '/enum/records.enum';

export default {
  reportName: REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO,
};
